/* eslint react/forbid-prop-types: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ThemeProvider } from '@material-ui/core/styles';
import MuiTheme from 'components/MuiTheme';
import classes from './SelectFormControl.module.scss';

const SelectFormControl = ({
  id,
  label,
  name,
  defaultValue,
  options,
  error,
  control,
}) => (
  <ThemeProvider theme={MuiTheme}>
    <div className={classes.selectFormControlContainer}>
      <FormControl error={!!error} fullWidth>
        <InputLabel>{label}</InputLabel>
        <Controller
          defaultValue={defaultValue}
          name={name}
          control={control}
          render={({ onChange, value }) => (
            <Select
              value={value}
              onChange={(val) => onChange(val)}
              inputProps={{
                name,
                id,
              }}
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          )}
        />
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </div>
  </ThemeProvider>
);

SelectFormControl.defaultProps = {
  error: '',
};

SelectFormControl.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  error: PropTypes.string,
  control: PropTypes.object.isRequired,
};

export default SelectFormControl;
